export default __webpack_public_path__ + "static/media/36I-114281_-20887_0.eb5259f7.jpg";